import React from 'react';
import styled from 'styled-components';
import TenantLogo from 'tenants/Logo';

const StyledLogoWrapper = styled.div`
    height: 64px;
    width: 100%;
    display: flex;
    color: white;
    flex-direction: row;
    margin-bottom: 0;
    justify-content: center;
    align-items: center;
`;

const Logo = () => {
    return (
        <StyledLogoWrapper className='logo-wrapper'>
            <TenantLogo />
        </StyledLogoWrapper>
    );
};

export default Logo;


// WEBPACK FOOTER //
// ./src/components/ui/general/Logo.js